import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Check, MoreVertical } from 'lucide-react';

const StatusMenu = ({ app, onStatusUpdate, className }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    
    const statusOptions = [
        { value: 'submitted', label: 'Submitted' },
        { value: 'under_review', label: 'Under Review' },
        { value: 'shortlisted', label: 'Shortlisted' },
        { value: 'interview', label: 'Interview' },
        { value: 'offer_extended', label: 'Offer Extended' },
        { value: 'hired', label: 'Hired' },
        { value: 'rejected', label: 'Rejected' }
    ];

    const handleClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (event) => {
        if (event) {
            event.stopPropagation();
        }
        setAnchorEl(null);
    };

    const handleStatusClick = (status) => {
        onStatusUpdate(app.id, status);
        handleClose();
    };

    return (
        <div className={className}>
            <IconButton
                aria-label="more"
                aria-controls={open ? 'status-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
                size="small"
                className="p-1 hover:bg-gray-200"
            >
                <MoreVertical size={16} />
            </IconButton>
            <Menu
                id="status-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                onClick={(e) => e.stopPropagation()}
                slotProps={{
                    paper: {
                        style: {
                            width: '200px',
                        },
                    },
                    list: {
                    'aria-labelledby': 'status-menu-button',
                }
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                // Prevents the menu from being cut off
                disableScrollLock={false}
                
            >
                <MenuItem disabled sx={{ py: 1, opacity: 1, cursor: 'default' }}>
                    <span className="text-xs text-gray-500 font-medium">Change Status</span>
                </MenuItem>
                {statusOptions.map((option) => (
                    <MenuItem 
                        key={option.value}
                        onClick={() => handleStatusClick(option.value)}
                        sx={{ 
                            py: 1.5,
                            fontSize: '0.875rem',
                            '&:hover': {
                                backgroundColor: 'rgba(0, 0, 0, 0.04)'
                            }
                        }}
                    >
                        <ListItemIcon sx={{ minWidth: 36 }}>
                            {app.status === option.value && (
                                <Check size={18} />
                            )}
                        </ListItemIcon>
                        <ListItemText 
                            primary={option.label}
                            sx={{ 
                                marginLeft: app.status === option.value ? 0 : '24px',
                                '& .MuiListItemText-primary': {
                                    fontSize: '0.875rem'
                                }
                            }}
                        />
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
};

export default StatusMenu;